<template>
  <div>
    <div class="mask" @click="close"></div>
    <div class="pop">
      <slot name="pop"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mask-pop',
  methods: {
    close () {
      this.$emit('close-confirm')
    }
  }
}
</script>

<style scoped>
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  z-index: 999;
}
</style>
